import { Select } from "ui";

type Props = {
  cameraNames: ReadonlyArray<string>;
  onChange: (cameraName: string) => void;
  value: string;
};

export function CameraSelect({ cameraNames, onChange, value }: Props) {
  return (
    <Select
      onChange={(labelAndValue) => onChange(labelAndValue!.value)}
      options={cameraNames.map((cameraName) => ({
        label: cameraName,
        value: cameraName,
      }))}
      placeholder=""
      value={{ label: value, value: value }}
    />
  );
}
